import ContentfulLink from './ContentfulLink'

export default ContentfulLink
